export default "__VITE_ASSET__7df71b6a__"